"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var hooks_1 = require("../../modules/sections/hooks");
var SectionTextRaw_1 = __importDefault(require("./SectionTextRaw"));
var SectionText = function (_a) {
    var id = _a.id;
    var sections = (0, hooks_1.useSections)().itemsByID;
    var section = sections[id];
    if (!section)
        return react_1.default.createElement("strong", null, "SECTION NOT FOUND");
    return react_1.default.createElement(SectionTextRaw_1.default, { title: section.title, color: section.color });
};
exports.default = SectionText;
